module.exports = __webpack_public_path__ + "img/blog1.19c24b9e.jpg";